// extracted by mini-css-extract-plugin
export default {"layerSetting":"index_layerSetting__DXIW8"};